const AlertTypes = {
    ATTENDANCE_ID: 1,
    OFF_PLAN_ID: 2,
    OVERALL_GPA_ID: 3,
    REGISTRATION_REMINDER_ID: 4,
    NO_ADVISOR_ID: 5,
    LOW_MIDTERM_GRADE_ID: 6,
    PAYMENT_REMINDER_ID: 7,
    NO_EMAIL_ADDRESS_ID: 8,
    LMS_LAST_LOGIN_ID: 9,
    LOW_CURRENT_GRADE_ID: 10,
    STAFF_INITIATED_EARLY_ALERT_ID: 11,
    FIRST_WEEK_ATTENDANCE_ONGROUND_ID: 12,
    ORIENTATION_COMPLETE_NO_REGISTRATION_ID: 13,
    ONLINE_FIRST_ASSIGNMENT_SUBMISSION_ID: 14,
    SELF_PACED_FIRST_ASSIGNMENT_SUBMISSION_ID: 15,
    SELF_PACED_NOTICE_TO_WITHDRAW_ID: 16,
};
export { AlertTypes };
